import styled from 'styled-components'

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const Fave = styled.div<{ isFaved?: boolean; isDisabled?: boolean }>`
  ${({ theme, isFaved, isDisabled }) => `
    width: 24px;
    height: 24px;

    svg {
      color: ${isFaved ? theme.palette.red100 : theme.palette.blueGray40};
      width: 24px;
      height: 24px;
      cursor: ${isDisabled ? 'default' : 'pointer'};
    }
  `}
`

export const Info = styled.div`
  ${({ theme }) => `
    display: flex;
    align-items: center;

    [type='profile'] {
      border-color: ${theme.palette.gray100};

      img[hidden] {
        display: none;
      }
    }
  `}
`

export const AvatarWrapper = styled.div`
  ${({ theme }) => `
    margin-right: ${theme.space.lg};
  `}
`

export const AboutMe = styled.div`
  ${({ theme }) => `
    font-size: ${theme.fontSize.xxs};
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.14;
    letter-spacing: 0.49px;
  `}
`

export const Actions = styled.div`
  display: flex;
  justify-content: space-between;

  .block-icon {
    margin-left: 8px;

    svg {
      color: ${({ theme }) => theme.palette.blueGray40};
      cursor: pointer;
    }

    &.blocked {
      svg {
        color: ${({ theme }) => theme.palette.red100};
      }
    }

    &.blocked-disabled {
      svg {
        cursor: default;
      }
    }
  }
`
